module.exports = __webpack_public_path__ + "static/media/Project3_Fig22.0fbb7e04.png";